import { render, staticRenderFns } from "./start_rework_dialog_rework_items.vue?vue&type=template&id=ff9a7544"
import script from "./start_rework_dialog_rework_items.vue?vue&type=script&lang=js"
export * from "./start_rework_dialog_rework_items.vue?vue&type=script&lang=js"
import style0 from "./start_rework_dialog_rework_items.vue?vue&type=style&index=0&id=ff9a7544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports